/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(function () {

setTimeout(function () {
  resizePlansCards();
}, 750);
$(window).resize(function () {
  resizePlansCards();
});
$(".shogun-tab-box").click(function () {
  setTimeout(function () {
    resizePlansCards();
  }, 750);
});
function resizePlansCards() {
  const cols = $(".col");
  let heights = [];
  cols.each(function (index, el) {
    $(this)
    .find(".section-row")
    .each(function (index, element) {
      $(element).height("auto");
      if ($(window).width() < 768) {
        return;
      }
      let elementHeight = $(element).height();
      if (!heights[index] || heights[index] < elementHeight) {
        heights[index] = elementHeight;
      } else {
        heights[index] = heights[index];
      }
    });
  });
  cols.each(function (index, el) {
    $(this)
    .find(".section-row")
    .each(function (index, element) {
      $(element).height(heights[index] + "px");
    });
  });
}

$(document).on("click", "input#single", function () {
  var element = $(this);
  var parentElement = element.closest(".ProductForm");

  parentElement.removeClass("Subscriber");
  $(".subscribe-message").hide();
});

$(document).on("click", "input#subscribe", function () {
  var element = $(this);
  var parentElement = element.closest(".ProductForm");

  parentElement.addClass("Subscriber");
  $(".subscribe-message").show();
});

$(document).on("click", "input#quick-add-single", function () {
  var element = $(this);
  var parentElement = element.closest(".ProductForm");

  parentElement.removeClass("Subscriber");
  $(".subscribe-message").hide();
});

$(document).on("click", "input#quick-add-subscribe", function () {
  var element = $(this);
  var parentElement = element.closest(".ProductForm");

  parentElement.addClass("Subscriber");
  $(".subscribe-message").show();
});

$(window).on("load", function () {
  var creatingSubscriptionFrequency = setInterval(function () {
    var freq_html = `<div class="ProductForm__Option FrequencySelect">
                      <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">`;

    $('.rc-selling-plans__label').addClass('ProductForm__Label').text('Delivered every: ');

    $('.rc_widget__option__plans__dropdown option').each(function (index, element) {
      var checked_text;
      var plan_option = $(this).data('plan-option'),
        value = $(this).val(),
        days = plan_option.replace(/[^0-9]/gi, ''),
        label_text = days + ' Days';

      if (index == 0) {
        checked_text = `value="${value}" checked`;
      } else {
        checked_text = `value="${value}"`;
      }

      freq_html += `<li class="HorizontalList__Item">
                      <input id="shipping_interval_frequency_${days}" class="SizeSwatch__Radio" name="shipping_interval" type="radio" ${checked_text}/>
                      <label for="shipping_interval_frequency_${days}" class="SizeSwatch">${label_text}</label>
                    </li>`;
    });

    freq_html += `</ul></div>`;

    if(!$('.FrequencySelect').length) {
      $('.rc-selling-plans').append(freq_html);
    }

    $('#frequencySelect_wrapper').append($('.rc-template__button-group .rc-selling-plans'));

    $(document).on('change', '.ProductForm__Option.FrequencySelect input.SizeSwatch__Radio', function () {
      var value = $(this).val();
      $('.rc_widget__option__plans__dropdown').val(value).change();
    });

    if ($('.ProductForm__Option.FrequencySelect').length > 0) {
      clearInterval(creatingSubscriptionFrequency);
    }
  }, 1000);

  var addingComparePrice = setInterval(function () {
    var onetimeRegPrice = $('#option-product-template-0-0').next().attr('data-regular_price');
    var subscribeRegPrice = $('#option-product-template-0-0').next().attr('data-sub_regular_price');

    var onetimePrice = $('#option-product-template-0-0').next().attr('data-comp_price');
    var subscribePrice = $('#option-product-template-0-0').next().attr('data-sub_disc');

    if (onetimeRegPrice != '' && subscribeRegPrice != '') {
      $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').html(onetimeRegPrice);
      $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').html(subscribeRegPrice);

      if($('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').hasClass('Price--highlight') || $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').hasClass('Price--highlight')) {
        $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').removeClass('Price--highlight');
        $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').removeClass('Price--highlight');
      }
    }

    if (onetimePrice != '' && subscribePrice != '' && onetimeRegPrice != '' && subscribeRegPrice != '') {
      var onetimeHTML =  `${onetimeRegPrice} <span class="Price Price--compareAt ProductSubscribe__Price Text--subdued u-h4"> ${onetimePrice}</span>`;
      var subscribeHTML = `${subscribeRegPrice} <span class="Price Price--compareAt ProductSubscribe__Price Text--subdued u-h4"> ${subscribePrice}</span>`;

      $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').addClass('Price--highlight').html(onetimeHTML);
      $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').addClass('Price--highlight').html(subscribeHTML);
    }

    if ($('.Price--compareAt').length > 0) {
      clearInterval(addingComparePrice);
    }
  }, 1000);

  setTimeout(function () {
    clearInterval(addingComparePrice);
  }, 2000);

  $('.ProductForm__Variants .ProductForm__Option[data-option-index="1"] .SizeSwatch__Radio').change(function () {
    clearInterval(addingComparePrice);
    var onetimeRegPrice = $(this).next().attr('data-regular_price');
    var subscribeRegPrice = $(this).next().attr('data-sub_regular_price');

    var onetimePrice = $(this).next().attr('data-comp_price');
    var subscribePrice = $(this).next().attr('data-sub_disc');

    if (onetimeRegPrice != '' && subscribeRegPrice != '') {
      setTimeout(function () {
        $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').html(onetimeRegPrice);
        $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').html(subscribeRegPrice);

        if($('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').hasClass('Price--highlight') || $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').hasClass('Price--highlight')) {
          $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').removeClass('Price--highlight');
          $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').removeClass('Price--highlight');
        }
      }, 100);
    }

    if (onetimePrice != '' && subscribePrice != '' && onetimeRegPrice != '' && subscribeRegPrice != '') {
      var onetimeHTML = `${onetimeRegPrice} <span class="Price Price--compareAt ProductSubscribe__Price Text--subdued u-h4"> ${onetimePrice}</span>`;
      var subscribeHTML = `${subscribeRegPrice} <span class="Price Price--compareAt ProductSubscribe__Price Text--subdued u-h4"> ${subscribePrice}</span>`;

      setTimeout(function () {
        $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').addClass('Price--highlight').html(onetimeHTML);
        $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').addClass('Price--highlight').html(subscribeHTML);
      }, 100);
    }

    var ProductForm__Variants = $(this).parents('.ProductForm__Variants');
    var SubscribeSelect = ProductForm__Variants.siblings('.SubscribeSelect');

    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.PriceOnetime__normal').html(onetimeRegPrice);
    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--highlight').html(onetimeRegPrice);
    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--compareAt').html(onetimePrice);
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.PriceSubs__normal').html(subscribeRegPrice);
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--highlight').html(subscribeRegPrice);
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--compareAt').html(subscribePrice);
  });

  $(document).on('change click', '.rc-template__button-group .rc-radio__input, .ProductForm__Option.FrequencySelect .SizeSwatch__Radio', function () {
    if ($(this).hasClass('rc-radio__input')) {
      if ($(this).hasClass('rc_widget__option__input--onetime')) {
        $('span.VariantData_Copy.Single.VariantData_Price.Text--subdued').show();
        $('span.VariantData_Copy.Subscribe.VariantData_Price.Text--subdued').hide();
        $("#klarna-placement-widget").show();
      } else {
        $('span.VariantData_Copy.Subscribe.VariantData_Price.Text--subdued').show();
        $('span.VariantData_Copy.Single.VariantData_Price.Text--subdued').hide();
        $("#klarna-placement-widget").hide();
      }
    }

    var onetimeRegPrice = $('.ProductForm__Variants .SizeSwatch__Radio:checked').next().attr('data-regular_price');
    var subscribeRegPrice = $('.ProductForm__Variants .SizeSwatch__Radio:checked').next().attr('data-sub_regular_price');

    var onetimePrice = $('.ProductForm__Variants .SizeSwatch__Radio:checked').next().attr('data-comp_price');
    var subscribePrice = $('.ProductForm__Variants .SizeSwatch__Radio:checked').next().attr('data-sub_disc');

    if (onetimeRegPrice != '' && subscribeRegPrice != '') {
      $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').html(onetimeRegPrice);
      $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').html(subscribeRegPrice);
    }
    if (onetimePrice != '' && subscribePrice != '' && onetimeRegPrice != '' && subscribeRegPrice != '') {
      $('.Price--compareAt').remove();
      var onetimeHTML = `${onetimeRegPrice} <span class="Price Price--compareAt ProductSubscribe__Price Text--subdued u-h4"> ${onetimePrice}</span>`;
      var subscribeHTML = `${subscribeRegPrice} <span class="Price Price--compareAt ProductSubscribe__Price Text--subdued u-h4"> ${subscribePrice}</span>`;

      $('.rc-radio.rc-option__onetime span.rc_widget__price--onetime').addClass('Price--highlight').html(onetimeHTML);
      $('.rc-radio.rc-option__subsave span.rc_widget__price--subsave').addClass('Price--highlight').html(subscribeHTML);
    }
  });
});



// Quick Add
var product = '';
var variants = '';
var recharge = '';
var discount_percentage = '';
var discount_percentage_decimal = '';
var glasshouse_metafields = '';
var okendo_metafields = '';
var options_with_values = '';
var variantsMeta = '';
var currentVariant = '';
var option1 = '';
var option2 = '';
var option3 = '';
var masterSelector = '';

var default_purchase_type = false;


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).on('click', 'button.quick-view', function (evt) {
  quickAddDrawer(evt.target)
});

function quickAddDrawer(target){
  $('#sidebar-cart .Drawer__Close').click();
  $('.PageOverlay').addClass('is-visible');

  var product_handle = $(target).attr('data-handle');

  jQuery.get(`/products/${product_handle}?view=json`, function (response) {

    response = JSON.parse(response);

    product = response.product;
    glasshouse_metafields = response.glasshouse_metafields;
    discount_percentage = parseInt(response.recharge.discount_percentage);
    discount_percentage_decimal = response.recharge.discount_percentage / 100;
    okendo_metafields = response.okendo_metafields;
    options_with_values = response.options_with_values;
    variantsMeta = response.variants;
    currentVariant = product.variants[0];
    option1 = product.variants[0]['option1'];
    option2 = product.variants[0]['option2'];
    option3 = product.variants[0]['option3'];

    var title = product.title;

    var tags = product.tags;
    var labels = '';

    var price = Shopify.formatMoney((Math.round(product.price) / 100).toFixed(2), window.theme.moneyFormat);
    var afterpayPrice = Shopify.formatMoney((Math.round(product.price * 0.25) / 100).toFixed(2), window.theme.moneyFormat);
    var subscribePrice = Shopify.formatMoney((Math.round(product.price * (1 - discount_percentage_decimal)) / 100).toFixed(2), window.theme.moneyFormat);

    $(tags).each(function (i, tag) {
      if (tag.includes('Label_')) {
        tag = tag.replace("Label_", "");
        labels = labels + '<span class="ProductItem__Label ProductItem__Label--' + tag + ' Heading Text--subdued">' + tag + '</span>';
      };
    });

    $('#quick-add-drawer .ProductMeta__Title').text(title);
    $('#quick-add-drawer .ProductItem__LabelList').html(labels);

    if (default_purchase_type) {
      $('#quick-add-drawer .ProductForm').addClass('Subscriber');
    } else {
      $('#quick-add-drawer .ProductForm').removeClass('Subscriber');
    }

    if (okendo_metafields.ProductListingSnippet) {
      $('#quick-add-drawer .prod__reviews').html(okendo_metafields.ProductListingSnippet);
    }

    $('#quick-add-drawer form').attr('id', 'quick-add-product_form_' + product.id);
    $('#quick-add-drawer form').attr('data-productid', product.id);

    var html = '';

    if (response.recharge.selling_plans != null){

      html += `<div class="ProductForm__Variants">`;

      variants = product.variants;

      html += `<span class="ProductForm__Label">Buying Options:</span>
              <div class="ProductForm__Option SubscribeSelect">
                <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">
                  <li class="HorizontalList__Item">`;

      if (default_purchase_type) {
        html += '				<input id="quick-add-single" class="SizeSwatch__Radio" type="radio" name="subscribe" value="false" price="0">';
      } else {
        html += '				<input id="quick-add-single" class="SizeSwatch__Radio" type="radio" name="subscribe" value="true" checked="checked" price="0">';
      }

      html += `				<label for="quick-add-single" class="SizeSwatch">One Time Purchase
                        <div class="ProductMeta__PriceList Heading"><span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible=""><span class="money">${price}</span></span></div>
                      </label>
                    </li>
                    <li class="HorizontalList__Item">`;

      if (default_purchase_type) {
        html += '				<input id="quick-add-subscribe" class="SizeSwatch__Radio" type="radio" name="subscribe" value="true" checked="checked" price="0">';
      } else {
        html += '				<input id="quick-add-subscribe" class="SizeSwatch__Radio" type="radio" name="subscribe" value="false" price="0">';
      }

      html += `				<label for="quick-add-subscribe" class="SizeSwatch">Subscribe &amp; Save ${discount_percentage}%
                        <div class="ProductSubscribe__PriceList Heading"><span class="ProductSubscribe__Price Price Text--subdued u-h4" data-money-convertible=""><span class="money">${subscribePrice}</span></span></div>
                      </label>
                    </li>
                  </ul>
              </div>`;

      $(options_with_values).each(function (index, option) {
        if (option.name == 'Flavour123') {

          var popover_id = 'quick-add-popover-product-template-flavour';

          html += `<button type="button" class="ProductForm__Item" aria-expanded="false" data-action="open-popover" aria-controls="${popover_id}">
                  <span class="ProductForm__OptionName">${option.name}: <span class="ProductForm__SelectedValue">${option.selected_value}</span></span><svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12"><polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline></svg>
                  </button>`;

          html += `<div class="Product__OffScreen">
                    <div id="${popover_id}" class="OptionSelector Popover Popover--withMinWidth Popover--positionLeft Popover--alignCenter" aria-hidden="true">`;

          var option_index = 'option' + option.position;

          html += `		<header class="Popover__Header">
                        <button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg></button>
                        <span class="Popover__Title Heading u-h4">${option.name}</span>
                      </header>`;

          html += `		<div class="Popover__Content">
                        <div class="Popover__ValueList" data-scrollable>`;

          $(option.values).each(function (index, value) {
            if (value == option.selected_value) {
              html += `			<button type="button" class="Popover__Value is-selected Heading Link Link--primary u-h6" value="${value}" data-option-position="${option.position}" data-action="quick-add-select-value">`;
            } else {
              html += `			<button type="button" class="Popover__Value Heading Link Link--primary u-h6" value="${value}" data-option-position="${option.position}" data-action="quick-add-select-value">`;
            };

            html += `${value}</button>`;
          });

          html += `		</div>
                    </div>
                  </div>`;

        } else {
          var optionIndex = `option${option.position}`;

          html += `	<div class="ProductForm__Option ProductForm__Option--labelled">
                      <span class="ProductForm__Label">${option.name}</span>
                        <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">`;

          $(option.values).each(function (j, value) {

            html += '				<li class="HorizontalList__Item">';

            if (j == 0) {
              html += `					<input id="quick-add-option-product-template-${index}-${j}" class="SizeSwatch__Radio" type="radio" name="quick-add-option-${index}-quick-add" value="${value}" checked="checked" data-option-position="${option.position}">`;
            } else {
              html += `					<input id="quick-add-option-product-template-${index}-${j}" class="SizeSwatch__Radio" type="radio" name="quick-add-option-${index}-quick-add" value="${value}" data-option-position="${option.position}">`;
            };

            html += `					<label for="quick-add-option-product-template-${index}-${j}" class="SizeSwatch">${value}`;

            var products_in_pack = parseInt(value.split(" ")[0]);

            if (!isNaN(products_in_pack)) {
              var min_price_for_variant = product.price;

              $(product.variants).each(function (k, variant) {
                if (variant[optionIndex] == value) {
                  min_price_for_variant = variant.price;
                };
              });

              html += `						<span class="ProductMeta__VariantData">
                                    <span class="VariantData_Copy Single VariantData_Price Text--subdued">
                                      <span class="money"><span class="money">${Shopify.formatMoney((Math.round(min_price_for_variant / products_in_pack) / 100).toFixed(2), window.theme.moneyFormat)} each</span></span>
                                    </span>

                                    <span class="VariantData_Copy Subscribe VariantData_Price Text--subdued">
                                      <span class="money"><span class="money">${Shopify.formatMoney((Math.round(min_price_for_variant / products_in_pack * (1 - discount_percentage_decimal)) / 100).toFixed(2), window.theme.moneyFormat)}' each</span></span>
                                    </span>

                                  </span>`;
            }

            html += `					</label>
                    </li>`;

          });

          html += `			</ul>
                      </span>
                    </div>`;
        }
      });

      html += `</div>
      <p class="afterpay-paragraph" style="" data-product-id="${product.id}"><span class="afterpay-text1">or 4 interest-free payments of </span><strong class="afterpay-instalments">${afterpayPrice}</strong><span class="afterpay-text2"> with </span><a class="afterpay-link" href="https://www.afterpay.com/terms" target="_blank"><img class="afterpay-logo" style="vertical-align:middle;" src="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png" srcset="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@3x.png 3x" width="100" height="21" alt="Afterpay"></a></p>`;

      if (response.recharge) {

        html += `<div class="subscribe-message">
                  <span class="ProductForm__Label">Delivered every:</span>`;

        var shipping_interval_unit_type = response.recharge.shipping_interval_unit_type || null;
        /*
        Author: Hemnys Chacón
        Company: DTC-Pages
        Date: 03-04-2024
        Description: I've updated the content and get the from native sellings plans instead of metafields

        Old code:
        var shipping_interval_frequency = response.recharge.shipping_interval_frequency || null;
        var selling_plans = response.recharge.selling_plans.split(',') || null;

        */
        const stringPlans = response.recharge.selling_plans.map( plan => plan.id);
        const stringPlansDays = response.recharge.selling_plans.map( plan => plan.options[0].value.replace(' Day(s)', '')).join(',');

        var selling_plans = stringPlans || null ;
        var shipping_interval_frequency = stringPlansDays || null;
        if (/<[^>]*>/g.test(shipping_interval_frequency)){
          let parser = new DOMParser();
          let doc = parser.parseFromString(shipping_interval_frequency, 'text/html');
          let textContent = doc.body.textContent;
          shipping_interval_frequency = textContent.split(',');
        } else {
          shipping_interval_frequency = shipping_interval_frequency.split(',');
        }

        html += `	<div class="ProductForm__Option FrequencySelect">
                    <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">`;

        $(shipping_interval_frequency).each(function (index, shipping_interval) {
          html += `			<li class="HorizontalList__Item">`;
          if (index == 0) {
            html += `				<input id="quick-add-shipping_interval_frequency_${shipping_interval}" class="SizeSwatch__Radio" type="radio" rc_shipping_interval_unit_type="${shipping_interval_unit_type}" rc_shipping_interval_frequency="${shipping_interval}" name="quick-add-shipping_interval" value="${selling_plans[index]}" checked>`;
          } else {
            html += `				<input id="quick-add-shipping_interval_frequency_${shipping_interval}" class="SizeSwatch__Radio" type="radio" rc_shipping_interval_unit_type="${shipping_interval_unit_type}" rc_shipping_interval_frequency="${shipping_interval}" name="quick-add-shipping_interval" value="${selling_plans[index]}">`;
          }

          html += `				<label for="quick-add-shipping_interval_frequency_${shipping_interval}" class="SizeSwatch">${shipping_interval} ${shipping_interval_unit_type}</label>
                      </li>`;
        });

        html += `		</ul>
                  </div>
                </div>`;
      }

      html += `<div class="no-js ProductForm__Option">
                <div class="Select Select--primary">
                  <svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12"><polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline></svg>
                  <select id="quick-add-product-select-${product.id}" name="id" title="Variant" data-productid="${product.id}">`;

      $(variants).each(function (j, variant) {
        var variantSubscriptionId = '';

        $(variantsMeta).each(function (k, variantMeta) {
          if (variantMeta.variantId == variant.id) {
            variantSubscriptionId = variantMeta.variantSubscriptionId;
            return false;
          }
        });

        if (j == 0) {
          html += `			<option selected="selected" value="${variant.id}" data-sku="${variant.sku}" data-subscription-id="${variantSubscriptionId}">${variant.title} - ${variant.price}</option>`;
        } else {
          html += `			<option value="${variant.id}" data-sku="${variant.sku}" data-subscription-id="${variantSubscriptionId}">${variant.title} - ${variant.price}</option>`;
        }
      });

      html += `		</select>
                </div>
              </div>
              <input type="hidden" name="quantity" value="1">`;

      $('#quick-add-drawer .FormContents').html(html);
      masterSelector = document.querySelector('#quick-add-product-select-' + product.id);
    } else {
      $('#quick-add-drawer .FormContents').html('');
    }

  });
}

$(document).on('click', '[data-action="open-popover"]', function () {
  var activator = $(this)[0];

  var popOverId = $(this).attr('aria-controls');

  var topPosition = 0,
    rightPosition = 0,
    position = 'left',
    alignment = 'center',
    threshold = 20;

  var windowHeight = window.innerHeight,
    activatorBoundingRect = activator.getBoundingClientRect(),
    halfHeight = windowHeight / 2;

  rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
  topPosition = activatorBoundingRect.top + activatorBoundingRect.height / 2;

  $('#' + popOverId).attr('aria-hidden', 'false');
  $('#' + popOverId)[0].setAttribute('style', 'transform: translateY(-50%); top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
});

function _onOptionChanged(target) {

  var data_option_position = target[0].getAttribute('data-option-position');

  if (data_option_position == 1) {
    option1 = target.val();
  } else if (data_option_position == 2) {
    option2 = target.val();
  } else if (data_option_position == 3) {
    option3 = target.val();
  }

  // Finally, we get the new variant
  previousVariant = currentVariant;
  currentVariant = _getCurrentVariantFromOptions();

  _onVariantChanged(previousVariant, currentVariant);

  if (currentVariant) {
    // We need to modify the hidden select that contain the id attribute as well
    masterSelector.querySelector('[selected]').removeAttribute('selected');
    masterSelector.querySelector('[value="' + currentVariant['id'] + '"]').setAttribute('selected', 'selected');
  }
};

function _getCurrentVariantFromOptions() {
  var found = false;

  variants.forEach(function (variant) {
    if (variant['option1'] === option1 && variant['option2'] === option2 && variant['option3'] === option3) {
      found = variant;
    }
  });

  return found || null;
}

function _addToCart(event) {

  var addToCartButton = document.querySelector('#quick-add-drawer .ProductForm__AddToCart');
  // First, we switch the status of the button
  addToCartButton.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  // Then we add the product in Ajax
  var formElement = document.querySelector('#quick-add-drawer form[action*="/cart/add"]');

  if ($('#quick-add-drawer #quick-add-subscribe').length && $('#quick-add-drawer #quick-add-subscribe').is(':checked') == true) {
    var subscribeId = parseInt(formElement.querySelector('[name="id"] option:checked').getAttribute('data-subscription-id'));
    var selling_plan_id = parseInt($('#quick-add-drawer [name="quick-add-shipping_interval"]:checked').val());

    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({
        id: subscribeId,
        quantity: 1,
        selling_plan: selling_plan_id
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        // We simply trigger an event so the mini-cart can re-render
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: currentVariant,
            quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
          }
        }));
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  } else {
    var variantChecked = formElement.querySelector('[name="id"] option:checked');
    var quantityChecked = formElement.querySelector('[name="quantity"]');
    var variantId = variantChecked ? variantChecked.value : currentVariant.id;

    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        // We simply trigger an event so the mini-cart can re-render
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: currentVariant,
            quantity: quantityChecked ? parseInt(quantityChecked.value) : 1
          }
        }));
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }

  if (window.reChargeCartJS) {
    window.reChargeCartJS();
  }

}

function _updateProductPrices(newVariant, previousVariant) {
  let productMetaPrices = document.querySelector('#quick-add-drawer .ProductMeta__PriceList');
  let productSubscribePrices = document.querySelector('#quick-add-drawer .ProductSubscribe__PriceList');
  let afterpayPriceEl = document.querySelector('.afterpay-instalments');
  let isSubscribeSelected = document.querySelector('#quick-add-subscribe').checked;

  if (!newVariant) {
    productMetaPrices.style.display = 'none';
    if (productSubscribePrices) {
      productSubscribePrices.style.display = 'none';
    }

  } else {
    if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
      return; // The price do not have changed so let's return to avoid changing the DOM for nothing
    }

    productMetaPrices.innerHTML = '';
    if (productSubscribePrices) {
      productSubscribePrices.innerHTML = '';
    }

    if (newVariant['compare_at_price'] > newVariant['price']) {
      productMetaPrices.innerHTML += `<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>${Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat)}</span><span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>${Shopify.formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat)}</span>`;

      if (productSubscribePrices) {
        productSubscribePrices.innerHTML += `<span class="ProductSubscribe__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>${Shopify.formatMoney((Math.round(newVariant['price'] * (1 - discount_percentage_decimal)) / 100).toFixed(2), window.theme.moneyFormat)}</span><span class="ProductSubscribe__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>${Shopify.formatMoney((Math.round(newVariant['compare_at_price'] * (1 - discount_percentage_decimal)) / 100).toFixed(2), window.theme.moneyFormat)}</span>`;
      }

      if (isSubscribeSelected) {
        let priceWithDiscount = Number(newVariant['compare_at_price'] - (Number(newVariant['compare_at_price'] * 0.2)));
        afterpayPriceEl.innerHTML = Shopify.formatMoney(((priceWithDiscount) / 4), window.theme.moneyFormat);
      } else {
        afterpayPriceEl.innerHTML = Shopify.formatMoney((newVariant['compare_at_price'] / 4), window.theme.moneyFormat);
      }
    } else {
      productMetaPrices.innerHTML += `<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>${Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat)}</span>`;
      if (productSubscribePrices) {
        productSubscribePrices.innerHTML += `<span class="ProductSubscribe__Price Price Text--subdued u-h4" data-money-convertible>${Shopify.formatMoney((Math.round(newVariant['price'] * (1 - discount_percentage_decimal)) / 100).toFixed(2), window.theme.moneyFormat)}</span>`;
      }

      if (isSubscribeSelected) {
        let priceWithDiscount = Number(newVariant['price'] - (Number(newVariant['price'] * 0.2)));
        afterpayPriceEl.innerHTML = Shopify.formatMoney(((priceWithDiscount) / 4), window.theme.moneyFormat);
      } else {
        afterpayPriceEl.innerHTML = Shopify.formatMoney((newVariant['price'] / 4), window.theme.moneyFormat);
      }
    }

    productMetaPrices.style.display = '';
    if (productSubscribePrices) {
      productSubscribePrices.style.display = '';
    }
  }
}

function _onVariantChanged(previousVariant, newVariant) {
  // 1st: the prices
  _updateProductPrices(newVariant, previousVariant);

  // Finally, we send an event so that other system could hook and do their own logic
  document.documentElement.dispatchEvent(new CustomEvent('variant:changed', {
    bubbles: true,
    detail: {
      variant: newVariant,
      previousVariant: previousVariant
    }
  }));
}

$(document).on('change', '#quick-add-drawer .ProductForm__Option [type="radio"]', function () {
  _onOptionChanged($(this));
});

$(document).on('click', '#quick-add-drawer [data-action="quick-add-select-value"]', function () {
  _onOptionChanged($(this));
});

$(document).on('click', '[data-action="quick-add-to-cart"]', function (event) {
  event.preventDefault(); // Prevent form to be submitted
  $('#quick-add-drawer .Drawer__Close').click();
  _addToCart();
});



if($(window).width() > 1023) {
  $(window).scroll(function() {
    var scrollTop = $(this).scrollTop();
    var toolbar_height = $('aside.ArticleToolbar').outerHeight(),
        header_height = $('#section-header').height(),
        total_offset = header_height + toolbar_height;
    $('.ArticleSidebarItem__Wrapper.article__wrapper-image').css('top', total_offset);
  });
}
});

// Aman subscription Code starts
$(document).ready(function () {
$(".custom-landing-page__AddToCart").click(function (event) {
  event.preventDefault();
  var product_handle = $(this).attr('data-product_handle');
  var current_selector = $(`.custom-landing-page-form[data-product_handle="${product_handle}"]`);
  var radioValue = current_selector.find(`input[name="subscribe-${product_handle}"]:checked`).val();
  if (radioValue == "true") {
    var selected_variant_id = parseInt(current_selector.find(`.ProductForm__Variants input[type="radio"]:checked`).attr('data-variant_id'));
    let data = {
      id: selected_variant_id,
      quantity: 1
    };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function (response) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent("product:added", {
          detail: {
            product: response
          }
        }));
      }
    });
  } else {
    var variant_subscription_id = parseInt(current_selector.find(`.ProductForm__Variants input[type="radio"]:checked`).attr('data-variant_id'));
    var selling_plan = parseInt(current_selector.find(`.FrequencySelect input[type="radio"]:checked`).val());
    let data = {
      id: variant_subscription_id,
      quantity: 1,
      selling_plan: selling_plan,
    };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function (response) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent("product:added", {
          detail: {
            product: response
          }
        }));
      }
    });
  }
});

$('.custom-landing-page-form .SubscribeSelect input[type=radio]').change(function () {
  var radioValue = $(this).val();
  var SubscribeSelect = $(this).parents('.SubscribeSelect');
  var frequencySelect_wrapper = SubscribeSelect.siblings('.frequencySelect_wrapper');
  var ProductForm__Variants = SubscribeSelect.siblings('.ProductForm__Variants');
  var ProductForm__Variants_LI = ProductForm__Variants.find('.SizeSwatchList li');
  if (radioValue == "true") {
    frequencySelect_wrapper.hide();
    ProductForm__Variants.find('.ProductMeta__VariantData .VariantData_Copy.Single.VariantData_Price').show();
    ProductForm__Variants.find('.ProductMeta__VariantData .VariantData_Copy.Subscribe.VariantData_Price').hide();
  } else {
    frequencySelect_wrapper.show();
    ProductForm__Variants.find('.ProductMeta__VariantData .VariantData_Copy.Subscribe.VariantData_Price').show();
    ProductForm__Variants.find('.ProductMeta__VariantData .VariantData_Copy.Single.VariantData_Price').hide();
  }
});

$('.custom-landing-page-form .ProductForm__Variants input[type=radio]').change(function () {
  var single_price = $(this).siblings('.SizeSwatch').attr('data-regular_price');
  var single_price_comp = $(this).siblings('.SizeSwatch').attr('data-comp_price');
  var subscription_price = $(this).siblings('.SizeSwatch').attr('data-sub_regular_price');
  var subscription_price_disc = $(this).siblings('.SizeSwatch').attr('data-sub_disc');
  var ProductForm__Variants = $(this).parents('.ProductForm__Variants');
  var SubscribeSelect = ProductForm__Variants.siblings('.SubscribeSelect');

  if(single_price_comp != '') {
    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.PriceOnetime__normal').addClass('Price--highlight').removeClass('PriceOnetime__normal');
    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--compareAt').show();
  } else {
    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--highlight').addClass('PriceOnetime__normal').removeClass('Price--highlight');
    SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--compareAt').hide();
  }
  SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.PriceOnetime__normal').html(single_price);
  SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--highlight').html(single_price);
  SubscribeSelect.find('.ProductMeta__PriceList .ProductSubscribe__Price.Price--compareAt').html(single_price_comp);

  if(single_price_comp != '') {
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.PriceSubs__normal').addClass('Price--highlight').removeClass('PriceSubs__normal');
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--compareAt').show();
  } else {
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--highlight').addClass('PriceSubs__normal').removeClass('Price--highlight');
    SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--compareAt').hide();
  }
  SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.PriceSubs__normal').html(subscription_price);
  SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--highlight').html(subscription_price);
  SubscribeSelect.find('.ProductSubscribe__PriceList .ProductSubscribe__Price.Price--compareAt').html(subscription_price_disc);
});
});

$('.gf_add-to-cart').click(function() {
var intervalId = setInterval(function() {
  if ($('#sidebar-cart').attr('aria-hidden') == 'false') {
    $('.PageOverlay').addClass('is-visible');
    $('#sidebar-cart .Drawer__Close').click(function(e) {
      e.preventDefault();
      $('#sidebar-cart').attr('aria-hidden', 'true');
      $('.PageOverlay').removeClass('is-visible');
    });
    clearInterval(intervalId);
  }
}, 50);

$('.PageOverlay').click(function() {
  $('#sidebar-cart').attr('aria-hidden', 'true');
  $('.PageOverlay').removeClass('is-visible');
});
});

// CountDown Timer Script
/*var countDownDate = new Date("April 9, 2023 12:29:00").getTime();

var x = setInterval(function() {
var now = new Date().getTime();
var distance = countDownDate - now;
var days = Math.floor(distance / (1000 * 60 * 60 * 24));
days = ('0' + days).slice(-2);
var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
hours = ('0' + hours).slice(-2);
var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
minutes = ('0' + minutes).slice(-2);
var seconds = Math.floor((distance % (1000 * 60)) / 1000);
seconds = ('0' + seconds).slice(-2);

  var content_wrapper = `<div class="time-left">
  <span class="days_left"> ${days}</span>
  <span class="days_left_text"> DAYS</spna>
  </div>
  <div class="time-left">
    <span class="days_left"> ${hours}</span>
    <span class="days_left_text"> HOURS </spna>
  </div>
  <div class="time-left">
    <span class="days_left"> ${minutes}</span>
    <span class="days_left_text"> MINUTES </spna>
  </div>
  <div class="time-left">
    <span class="days_left"> ${seconds}</span>
    <span class="days_left_text"> SECONDS </spna>
  </div>
  `
  document.getElementById("demo").innerHTML = content_wrapper;
if (distance < 0) {
  clearInterval(x);
  document.getElementById("demo").innerHTML = "EXPIRED";
}
}, 1000);*/

// TIENDA link replace code
document.addEventListener("DOMContentLoaded", function() {
    var langLinkCurrentUrl = window.location.href;

    // Select all elements that have the data-link-es attribute
    var langLinkElements = document.querySelectorAll('[data-link-es]');

    // Check if any elements were found
    if (langLinkElements.length > 0) {
        langLinkElements.forEach(function(langLinkElement) {
            // Get the default link, falling back to href if data-link is not set
            var langLinkDefaultLink = langLinkElement.getAttribute('href') || langLinkElement.getAttribute('data-link');
            var langLink = langLinkDefaultLink; // Default link

            // Check the current URL and assign the appropriate link if it's not empty
            if (langLinkCurrentUrl.includes('tienda.happymammoth.com')) {
                var langLinkEs = langLinkElement.getAttribute('data-link-es');
                if (langLinkEs && langLinkEs.trim() !== '') {
                    langLink = langLinkEs;
                }
            }

            // Set the href attribute to the determined link
            langLinkElement.setAttribute('href', langLink);
        });
    }
});
